import React from "react";

export const EditorialIcon = ({ icon: Icon, testId, className = "" }) => (
  <span className={`editorial-icon ${className}`} aria-hidden="true" data-testid={testId}>
    <Icon strokeWidth={1.5} focusable="false" />
  </span>
);

const ILLUSTRATIONS = {
  insulation: "Conceptual architectural illustration: a navy structural enclosure protects a group of blocks, with controlled paths through its boundary.",
  leadership: "Conceptual architectural illustration: supported platforms lead towards an open structural gateway.",
  research: "Conceptual architectural illustration: separated layers are held in alignment, revealing the structure beneath.",
};

export const ArchitectureIllustration = ({ kind, testId, className = "", priority = false }) => (
  <figure className={`architecture-illustration ${className}`} data-testid={testId}>
    <img
      src={`/images/${kind}.webp`}
      alt={ILLUSTRATIONS[kind]}
      width="1264"
      height="848"
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      data-testid={`${testId}-image`}
    />
  </figure>
);